import axios from "axios";
import qs from "qs";
import _ from "lodash";
import { useSelector } from "react-redux";
import { isProduction, MIX_PANEL_KEY } from "constants/configs";

if (MIX_PANEL_KEY == null) {
  // eslint-disable-next-line no-console
  console.error("Mix Panel Key is not configured properly.");
}

const mixPanelTrackEvent = async (
  eventName,
  otherFields,
) => {
  try {
    await axios.post(
      "https://api.mixpanel.com/track",
      qs.stringify({
        data: JSON.stringify({
          event: eventName,
          properties: {
            token: MIX_PANEL_KEY,
            ...otherFields,
          },
        }),
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Mix Panel Error.", e);
  }
};

export const setProfileApi = async (
  session,
) => {
  try {
    const { email, currentWorkspace, firstName, lastName} = _.get(session, 'user', {});
    if (email) {
      await axios.post(
        "https://api.mixpanel.com/engage",
        qs.stringify({
          data: JSON.stringify({
            $token: MIX_PANEL_KEY,
            $distinct_id: email,
            $set: {
              currentWorkspace,
              $name: `${firstName} ${lastName}`,
              $email: email,
            },
          }),
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("Error while setting profile to mixPanel", err);
  }
};

const useMixPanel = () => {
  const session = useSelector((globalState) => globalState.session);
  const hostURL = _.get(window, "location.host", "No Host?");
  const userEmail = _.get(session, "user.email", "--");

  const payload = {
    distinct_id: userEmail,
    $transaction: userEmail,
  };

  const userAgent = {
    browser: (() => {
      const ua = navigator.userAgent;
      if (ua.indexOf("Firefox") > -1) return "Firefox";
      if (ua.indexOf("Chrome") > -1) return "Chrome";
      if (ua.indexOf("Safari") > -1) return "Safari";
      if (ua.indexOf("Edge") > -1) return "Edge";
      return "Other";
    })(),
    cookieEnabled: navigator.cookieEnabled,
    browserLanguage: navigator.language,
    computerOS: (() => {
      const ua = navigator.userAgent;
      if (ua.indexOf("Win") > -1) return "Windows";
      if (ua.indexOf("Mac") > -1) return "MacOS";
      if (ua.indexOf("Linux") > -1) return "Linux";
      if (ua.indexOf("Android") > -1) return "Android";
      if (ua.indexOf("iPhone") > -1 || ua.indexOf("iPad") > -1) return "iOS";
      return "Other";
    })(),
    userAgent: navigator.userAgent,
    hostURL,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  const event = (eventName, extraFields) => {
    // eslint-disable-next-line no-console
    console.log(`EVENT: ${eventName} | payload: ${JSON.stringify(payload)}`);
    if(
      isProduction && MIX_PANEL_KEY !== null
    ) {
        mixPanelTrackEvent(
        eventName,
        { ...payload, ...extraFields, ...userAgent },
      );
    }
  };

  const setProfile = () => {
    if(isProduction && MIX_PANEL_KEY !== null) {
      setProfileApi(session, isProduction);
    } else {
      // eslint-disable-next-line no-console
      console.log("LOCAL | Profile Set | payload: ", payload);
    }
  };

  return { event, setProfile };
};

export default useMixPanel;
